// extracted by mini-css-extract-plugin
export default {"container":"Hda-z","productName":"Ida-z","price":"Jda-z","dimensions":"Kda-z"};